// The gate token now lives in an httpOnly cookie the browser JS cannot read.
// Only a non-sensitive expiry hint is cached, purely to avoid an auth flash on first paint.
const HINT = "aegis.gate.expires";

export function gateHint() {
  const raw = window.localStorage.getItem(HINT);
  if (!raw) return null;
  if (new Date(raw).getTime() <= Date.now()) {
    window.localStorage.removeItem(HINT);
    return null;
  }
  return raw;
}

export function saveGateHint(expiresAt) {
  if (expiresAt) window.localStorage.setItem(HINT, expiresAt);
}

export function clearGate() {
  window.localStorage.removeItem(HINT);
}
